import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when User toggles balance visibility.
 * @memberOf Playtech.API.events
 * @event user:lowBalanceCheck
 * @type {callback}
 * @param {Object[]} details
 * @param {boolean} details[].lowBalanceHighlight
 * @param {boolean} details[].showLowBalancePopup
 * @example Playtech.on('user:lowBalanceCheck', ([{ lowBalanceHighlight, showLowBalancePopup }]) => { ... });
 */
export const EVENT_USER_LOW_BALANCE_CHECK = 'user:lowBalanceCheck';

export const useOnUserLowBalanceCheck = (eventTarget) => {
    const handleEvent = useCallback(({ lowBalanceHighlight, showLowBalancePopup }) => {
        const event = new CustomEvent(EVENT_USER_LOW_BALANCE_CHECK, {
            detail: [{ lowBalanceHighlight, showLowBalancePopup }]
        });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(EVENT_USER_LOW_BALANCE_CHECK, handleEvent);

        return () => {
            publicEventsAPIService.off(EVENT_USER_LOW_BALANCE_CHECK, handleEvent);
        };
    }, [handleEvent]);
};
